import { useEffect } from 'react'

export const useGoogleOneTap = ({
  callback,
}: {
  callback: (token: string) => void
}) => {
  return {
    prompt: () => {
      if (!window.google?.accounts) {
        console.log('google client not initialized')
        return
      }

      window.google.accounts.id.initialize({
        client_id: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
        callback: (response) => callback(response.credential),
      })

      window.google.accounts.id.prompt()
    },
  }
}
